"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toWire = toWire;
exports.fromWire = fromWire;
const coders_1 = require("./coders");
function toWire(object) {
    if (object === undefined)
        return undefined;
    if (object === null)
        return null;
    if (Array.isArray(object)) {
        const newArray = [];
        for (let i = 0; i < object.length; i++)
            newArray.push(toWire(object[i]));
        return newArray;
    }
    if (typeof object === "object") {
        for (const coder of coders_1.Coders)
            if (coder.testEncode(object))
                return coder.encode(object);
        const newObject = {};
        for (const key of Object.keys(object))
            newObject[key] = toWire(object[key]);
        return newObject;
    }
    return object;
}
function fromWire(object) {
    if (object === null)
        return null;
    if (object === undefined)
        return undefined;
    if (Array.isArray(object)) {
        for (let i = 0; i < object.length; i++)
            object[i] = fromWire(object[i]);
        return object;
    }
    for (const coder of coders_1.Coders)
        if (coder.testDecode(object))
            return coder.decode(object);
    if (typeof object === "string") {
        if (object === "true")
            return true;
        if (object === "false")
            return false;
        if (/^[0-9]+$/.test(object))
            return Number.parseInt(object, 10);
        if (/^[0-9]+\.[0-9]+$/.test(object))
            return Number.parseFloat(object);
    }
    if (typeof object === "object") {
        for (const key of Object.keys(object))
            object[key] = fromWire(object[key]);
        return object;
    }
    return object;
}
//# sourceMappingURL=index.js.map